module.exports = __webpack_public_path__ + "img/aicad_el_futuro.61f551dc.jpg";